<template>
  <b-container v-if="createAny('facturen')" fluid>
    <!--Title bar -->
    <div class="title-bar">
      <h1>{{ $t("labels.verzamelinvoice").toLowerCase() }}</h1>
    </div>
    <b-row class="filter-bar">
      <b-col md="4" xl>
        <b-form-group :label="$t('labels.from')">
          <flat-pickr v-model="startdate" :config="config" class="form-control" placeholder="Select date" name="startdate" />
        </b-form-group>
      </b-col>
      <b-col md="4" xl>
        <b-form-group :label="$t('labels.to')">
          <flat-pickr v-model="enddate" :config="config" class="form-control" placeholder="Select date" name="enddate" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="true"
      ><b-col cols="8">
        <b-row>
          <b-col cols="2">{{ $t("titles.companies") }}</b-col>
          <b-col cols="6">
            <v-select multiple :options="current_companies" label="company_name" v-model="selected_companies"></v-select>
          </b-col>
        </b-row> </b-col
    ></b-row>
    <div v-if="notrunning" class="row">
      <div @click="email_invoices()" class="btn btn-primary"><font-awesome-icon icon="envelope" /> {{ $t("buttons.emailinvoices") }}</div>
      <div @click="export_invoices()" class="btn btn-primary"><font-awesome-icon icon="file-export" /> {{ $t("buttons.exportinvoices") }} {{ settings.boekhoudprogramma }}</div>

      <b-col md="4" xl>
        <b-dropdown id="dropdown-dropup" dropup :text="$t('buttons.selectemailinvoices')" variant="primary">
          <b-dropdown-item @click="select_all_email()"> <font-awesome-icon icon="plus" /> {{ $t("buttons.selectall") }} </b-dropdown-item>
          <b-dropdown-item @click="select_none_email()"> <font-awesome-icon icon="minus" /> {{ $t("buttons.selectnone") }} </b-dropdown-item>
          <b-dropdown-item @click="select_not_emailed()"> <font-awesome-icon icon="check" /> {{ $t("buttons.selectnotmailed") }} </b-dropdown-item>
        </b-dropdown>

        <b-dropdown id="dropdown-dropup" dropup :text="$t('buttons.selectexportinvoices')" variant="primary">
          <b-dropdown-item @click="select_all_export()"> <font-awesome-icon icon="plus" /> {{ $t("buttons.selectall") }} </b-dropdown-item>
          <b-dropdown-item @click="select_none_export()"> <font-awesome-icon icon="minus" /> {{ $t("buttons.selectnone") }} </b-dropdown-item>
          <b-dropdown-item @click="select_not_exported()"> <font-awesome-icon icon="check" /> {{ $t("buttons.selectnotexported") }} </b-dropdown-item>
        </b-dropdown>
      </b-col>

      <div class="col">
        <b-form-checkbox v-model="showcomplete" name="checkbox-1" value="1" unchecked-value="0">
          {{ $t("buttons.showcomplete") }}
        </b-form-checkbox>
      </div>
    </div>

    <b-table :items="filteredinvoices" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" sort-icon-left>
      <template #cell(sale_invoice)="row">
        <a class="action-item" href="javascript:;" @click="generate_combined(row.item)" :title="$t('labels.invoice_verkoop')">
          <font-awesome-icon v-if="!row.item.pdfgenerating" icon="file-invoice" />
          <b-spinner small v-else></b-spinner>
        </a>
      </template>
      <template #cell(sale)="row">
        {{ row.item.sale.toLocaleString(undefined, { minimumFractionDigits: 2, style: "currency", currency: "EUR" }) }}
        <strong>{{ row.item.hourcode ? (hourcode_by_id(Number(row.item.hourcode)) ? hourcode_by_id(Number(row.item.hourcode)).name : $t("labels.hourcategoryname")) : $t("labels.total") }}</strong>
        <a class="action-item" href="javascript:;" @click="setsaleamount(row.item)">
          <font-awesome-icon icon="pen" />
        </a>
      </template>
      <template #cell(salemailed)="row">
        <font-awesome-icon v-if="row.item.salemailed" icon="check" style="color: green" />
        <font-awesome-icon v-else icon="times" style="color: red" />
      </template>
      <template #cell(invoicedate)="row">
        {{ dateToNL(row.item.invoicedate) }}
      </template>
      <template #cell(project)="row">
        <a :href="'/#/project/' + row.item.project_id" :style="{ cursor: 'pointer' }" class="link-item"> {{ project_by_id(row.item.project_id).title }} </a>
      </template>
      <template #cell(salemailselect)="row">
        <input type="checkbox" :id="'scheck-' + row.item.id" v-model="row.item.salemailselect" @change="smailcheck(row.item)" />

        <font-awesome-icon v-if="row.item.salemailwarning" icon="question" class="table-contacts-roles" />
      </template>
      <template #cell(saleexported)="row">
        <font-awesome-icon v-if="row.item.saleexported" icon="check" style="color: green" />
        <font-awesome-icon v-else icon="times" style="color: red" />
      </template>
      <template #cell(saleexportselect)="row">
        <input type="checkbox" :id="'sexportcheck-' + row.item.id" v-model="row.item.saleexportselect" @change="sexportcheck(row.item)" />
        <font-awesome-icon v-if="row.item.saleexportwarning" icon="question" class="table-contacts-roles" />
      </template>
      <template #cell(company_name)="row">
        <a :href="'/#/company/' + project_by_id(row.item.project_id).company_id" :style="{ cursor: 'pointer' }" class="link-item"> {{ company_by_id(project_by_id(row.item.project_id).company_id).company_name }} </a>
      </template>
    </b-table>
    <b-pagination v-if="false" v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>

    <div v-if="notrunning">
      <div @click="email_invoices()" class="btn btn-primary"><font-awesome-icon icon="envelope" /> {{ $t("buttons.emailinvoices") }}</div>
      <div @click="export_invoices()" class="btn btn-primary"><font-awesome-icon icon="file-export" /> {{ $t("buttons.exportinvoices") }} {{ settings.boekhoudprogramma }}</div>
      <div v-if="current_user.id == 1" @click="email_status(1)" class="btn btn-primary"><font-awesome-icon icon="check" /> set email send</div>
      <div v-if="current_user.id == 1" @click="email_status(0)" class="btn btn-primary"><font-awesome-icon icon="times" /> set email not send</div>
      <div v-if="current_user.id == 1" @click="export_status(1)" class="btn btn-primary"><font-awesome-icon icon="check" /> set export on</div>
      <div v-if="current_user.id == 1" @click="export_status(0)" class="btn btn-primary"><font-awesome-icon icon="times" /> set export off</div>
    </div>
    <BSUploadUserModal :contract_id="contract_id" :weeknumber="weeknumber" :yearnumber="yearnumber" :companyattachment="companyattachment" />

    <BSSetSaleAmountCombined :factuur_id="showinvoice" />
    <BSsetFacNumModel :factuur_id="showinvoice" />
    <BSManageUrenbonnenModalID :weekurenbonnen="urenbonnenfromrow" />
    <BSShowinvoiceDataID v-if="selectedinvoice != null" :contract="selectedinvoice" :inkoop="purchase == 'yes'" />
  </b-container>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import axios from "axios";
import popup_modal from "./modals/PopupModal.vue";
// import BSSetInvoiceData from "./modals/BSSetInvoiceData.vue";
import BSUploadUserModal from "./modals/BSUploadUrenModal.vue";
import BSManageUrenbonnenModalID from "./modals/BSManageUrenbonnenModal.vue";
import BSShowinvoiceDataID from "./modals/BSShowInvoiceData.vue";
import BSsetFacNumModel from "./modals/BSsetFacNumModel.vue";
import BSSetSaleAmountCombined from "./modals/BSSetSaleAmountCombined.vue";
import popup_confirm from "./modals/PopupConfirm.vue";

// import router from '../router'

const Dutch = require("flatpickr/dist/l10n/nl.js").default.nl;

export default {
  name: "InvoicesScreen",
  data() {
    return {
      startdate: "",
      enddate: "",
      purchase: "yes",
      sortBy: "agree_date",
      sortDesc: true,
      sortDirection: "asc",
      notrunning: true,
      filter: null,
      showinvoice: 0,
      weeknumber: 0,
      yearnumber: 0,
      contract_id: 0,
      companyattachment: false,
      internattachment: false,
      showcomplete: 0,
      showmanual: 1,
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      urenbonnenfromrow: [],
      selectedinvoice: null,
      config: {
        weekNumbers: true,
        locale: Dutch,
        altInput: true,
        altFormat: "d-m-Y",
        dateFormat: "Y-m-d",
      },
      selectedID: 0,
      gen_invoice_busy: false,
      allinvoices_gen: [],
      selected_id: null,
      selected_companies: null,
      showoptions: false,
      generating: false,
      generated: false,
    };
  },
  mounted() {
    // setTimeout(()=>{this.generating=true; this.showoptions = true}, 1000)

    console.log("mounted invoices");
    this.startdate = this.getMonday(new Date());
    this.startdate.setDate(this.startdate.getDate() - 7);

    this.enddate = new Date();
    this.enddate.setDate(this.startdate.getDate() + 7);
    // this.startdate = new Date("2025-10-13");
    // this.enddate = new Date("2023-11-27");
    this.showmanual = this.getOverWrite("showmanual");
  },
  beforeMount() {
    this.purchase = this.$route.params.sale == "purchase" ? "yes" : "no";
  },
  computed: {
    filteredinvoices() {
      if (this.selected_companies == null || this.selected_companies.length == 0) {
        return this.invoicedata;
      } else {
        if (this.selected_companies != null && this.selected_companies.length > 0) {
          let company_ids = [...new Set(this.selected_companies.map((item) => item.id))];
          return this.invoicedata.filter((iv) => company_ids.indexOf(iv.company_id) != -1);
        }
      }
      return null;
    },
    invoicedata() {
      let ret = [];
      //  return ret
      let locweek = this.weeks;
      // console.log("invoicedata ", this.facturen.length, this.weeks)
      this.combinedfacturen
        .filter((f) => locweek.indexOf(f.week) != -1 && this.validinperiode(f))
        .forEach((factuur) => {
          let week = factuur.week;
          let thisYear = this.getYearvalue(new Date(this.startdate));
          thisYear = this.getWeekNumber(this.startdate)[0];
          if (week < locweek[0]) {
            thisYear += 1;
          }
          //check companyattachment
          // let companyattachment =this.company_attachment({company_id:this.project_by_id(factuur.project_id).company_id, urenbonnen: this.urenbonnen.filter(bon => bon.contract_id == factuur.contract_id && bon.week == factuur.week)})
          if (parseFloat(factuur.invoiceamountsale) != -1)
            ret.push({
              id: factuur.id,
              week: factuur.week < 10 ? "0" + factuur.week + "-" + thisYear : factuur.week + "-" + thisYear,
              year: factuur.year,
              contract_id: factuur.contract_id,
              hourcode: factuur.hourcode,
              company_id: this.project_by_id(factuur.project_id).company_id,
              company_name: this.company_by_id(this.project_by_id(factuur.project_id).company_id).company_name,
              project_id: factuur.project_id,
              invoicedate: factuur.invoicedate,

              sale: parseFloat(factuur.invoiceamountsale),
              salefull: this.saleFull(factuur.project_id, factuur.week, factuur.year),
              salemailed: factuur.mailedverkoop,
              salemailselect: factuur.mailedverkoop == 1 ? 0 : 1,
              salemailwarning: false,
              saleexported: factuur.exportedverkoop,
              saleexportselect: factuur.exportedverkoop == 1 ? 0 : 1,
              saleexportwarning: false,
              pdfgenerating: false,
              facnumverkoop: factuur.facnumverkoop,
              senddate: factuur.senddate,
              boekstuknummer: factuur.boekstuknummer,
              invoiceemail: this.company_by_id(this.project_by_id(factuur.project_id).company_id).invoice_contants[0] ? this.user_by_id(this.company_by_id(this.project_by_id(factuur.project_id).company_id).invoice_contants[0]).id : null,
            });
        });
      // console.log("ïnvooicedataend", ret.length)

      return ret.filter((id) => {
        return id.saleexported != true || id.salemailed != true || (id.saleexported == true && this.showcomplete == "1" && id.salemailed == true);
      });
    },
    weeks() {
      var loop = new Date(this.startdate);
      var endd = new Date(this.enddate);
      let locweeks = [];
      while (loop <= endd) {
        let thisday = this.dateToYYYYMMDD(loop);
        var newDate = loop.setDate(loop.getDate() + 1);
        loop = new Date(newDate);
        var week = this.getWeekNumbervalue(new Date(thisday));
        if (locweeks.indexOf(week) == -1) {
          locweeks.push(week);
        }
      }
      return locweeks;
    },
    /*
    invoiceType() {
      return this.purchase=="yes"?this.$i18n.t('labels.purchase'):this.$i18n.t('labels.sale')
    },
    current_zzpers(){
      let ids = [...new Set(this.invoicedata.map(item => item.user_id))]

      return this.zzpers.filter(u => ids.indexOf(u.id) !=-1)
    },

    dates() {
      var loop = new Date(this.startdate);
      var endd = new Date(this.enddate);
      let alldates = []
      let weeks =[]
      while (loop <= endd) {
        let thisday = this.dateToYYYYMMDD(loop)
        var newDate = loop.setDate(loop.getDate() + 1);
        alldates.push(thisday)
        loop = new Date(newDate);
        var week = this.getWeekNumbervalue(new Date(thisday))
        if(weeks.indexOf(week)==-1){
          weeks.push(week)
        }

      }
      return alldates;
    },
    weeks() {
      var loop = new Date(this.startdate);
      var endd = new Date(this.enddate);
      let locweeks =[]
      while (loop <= endd) {
        let thisday = this.dateToYYYYMMDD(loop)
        var newDate = loop.setDate(loop.getDate() + 1);
        loop = new Date(newDate);
        var week = this.getWeekNumbervalue(new Date(thisday))
        if(locweeks.indexOf(week)==-1){
          locweeks.push(week)
        }

      }
      return locweeks;
    },


    allinvoices(){
      if(this.allinvoices_gen.length>0){
        return this.allinvoices_gen
      } else {
        this.generateallinvoices()
        return this.allinvoices_gen;
      }
    },
*/
    fields() {
      return [
        { key: "invoicedate", label: this.$i18n.t("tableheaders.signed"), sortable: true, sortDirection: "asc" },
        { key: "week", label: this.$i18n.t("labels.week"), sortable: true, sortDirection: "desc" },
        { key: "facnumverkoop", sortable: true, sortDirection: "asc" },
        { key: "company_name", label: this.$i18n.t("labels.client"), sortable: true, sortDirection: "desc" },
        { key: "project", label: this.$i18n.t("labels.projectname") },
        { key: "sale", label: this.$i18n.t("labels.amount"), sortable: true, sortDirection: "desc" },
        { key: "salemailed", label: this.$i18n.t("labels.ismailed"), sortable: true, sortDirection: "desc" },
        { key: "salemailselect", label: this.$i18n.t("labels.mail") },
        { key: "sale_invoice", label: this.$i18n.t("labels.invoice"), sortable: true, sortDirection: "desc" },
        { key: "saleexported", label: this.$i18n.t("labels.isexported"), sortable: false, sortDirection: "desc" },
        { key: "saleexportselect", label: this.$i18n.t("labels.export") },
      ];
    },
    current_companies() {
      let ids = [];
      this.combinedfacturen.forEach((fac) => {
        let company_id = this.project_by_id(fac.project_id).company_id;
        if (ids.indexOf(company_id) == -1) {
          ids.push(company_id);
        }
      });
      return this.companies.filter((c) => ids.indexOf(c.id) != -1);
    },
    ...mapState(["combinedfacturen", "hours", "settings", "urenbonnen", "planning", "current_user", "users", "companies"]),
    ...mapGetters(["server_url", "username_by_id", "user_by_id", "project_by_id", "contract_by_id", "company_by_id", "combinedfactuur_by_id", "confirm_modal", "createAny", "hourcode_by_id", "zzpers"]),
  },
  methods: {
    constructsearch() {
      this.generating = true;
      setTimeout(() => {
        this.showoptions = true;
      }, 10);
    },
    ...mapActions(["delete_factuur"]),
    saleFull(project_id, week, year) {
      // console.log(this.project_by_id(project_id), week, year);
      let declacosts = [];

      this.project_by_id(project_id).zzprusers.forEach((zzpr) => {
        let contract = this.contracts.filter((c) => c.user_id == zzpr && c.project_id == project_id);
        if (contract.length > 0) {
          let contract_id = contract[0].id;

          // let usercontract = this.planning.filter((up) => up.id == this.contract_by_id(contract_id).planning_id)[0];
          let workdates = this.getWeekDates(week, year);
          let userhoursinweek = this.hours.filter((h) => h.contract_id == contract_id && h.user_id == zzpr && h.agree_company == 1 && workdates.indexOf(h.workdate) != -1);
          if (userhoursinweek.length > 0) {
            userhoursinweek.forEach((uh) => {
              if (this.settings.enableMinHoursSale && uh.hours > 0 && this.contract_by_id(contract_id).minhourssale && uh.hours < parseFloat(this.contract_by_id(contract_id).minhourssale)) {
                uh.hours = parseFloat(this.contract_by_id(contract_id).minhourssale);
              }
              this.contract_by_id(contract_id)
                .onregelmatig.filter((or) => or.active == 1)
                .forEach((onregelItem) => {
                  let onregelRule = this.declaratie_by_id(onregelItem.declaratie_id);
                  // console.log(uh.workdate, onregelRule.name, zzpr);
                  let thisdecl = {};

                  thisdecl.id = onregelItem.declaratie_id;
                  thisdecl.costs = 0;
                  let dc = declacosts.filter((dc) => dc.id == onregelItem.declaratie_id);
                  if (dc.length > 0) thisdecl = dc[0];

                  if (declacosts.filter((dc) => dc.id == onregelItem.declaratie_id))
                    if (onregelRule.type == "total" && uh[onregelRule.name]) {
                      thisdecl.costs += parseFloat(uh[onregelRule.name]);
                    } else {
                      if (onregelItem.client_amount && uh[onregelRule.name]) {
                        thisdecl.costs += parseFloat(onregelItem.client_amount) * uh[onregelRule.name];
                      }
                    }
                  if (declacosts.filter((dc) => dc.id == thisdecl.id).length == 0) declacosts.push(thisdecl);
                });
            });
          }
        }
      });
      return declacosts;
    },
    debnumcheck(debcheck) {
      // console.log("debcheck", debcheck)
      if (debcheck && this.user_by_id(debcheck).debnum == undefined) {
        return { lastname: "warning" };
      }
      return {};
    },
    validinperiode(invoice) {
      let facyear = "20" + invoice.facnumverkoop.substring(1, 3);
      var w = this.getWeekOfYear(parseInt(facyear), parseInt(invoice.week))[0];
      // if(new Date(w).setHours(0, 0, 0)>=new Date(this.startdate).setHours(0, 0, 0))
      // console.log(w, this.startdate)
      // console.log(invoice.facnumverkoop.substring(1,3),invoice.week,   this.weeks)
      return new Date(w).setHours(0, 0, 0) >= new Date(this.startdate).setHours(0, 0, 0);
    },
    generateallinvoices() {
      let result = [];
      /*      let year = new Date().getFullYear().toString().substring(2)
        this.facturen.filter(f=>
          {
            // console.log(f.facnumverkoop.substring(1,3) ,year.substring(2))
            // return f.facnumverkoop.substring(1,3) == year
            return true
          }
        ).forEach(fac => {
          */
      this.facturen.forEach((fac) => {
        let contract = this.contract_by_id(fac.contract_id);
        if (contract) {
          // remove purchase invoices when ZZP-er generates own invoices
          let cpfac = {};
          cpfac.week = fac.week;
          cpfac.hourcode = fac.hourcode;
          cpfac.facnuminkoop = fac.facnuminkoop + " " + this.username_by_id(contract.user_id) + " Wk" + fac.week;
          cpfac.facnumverkoop = fac.facnumverkoop + " " + this.username_by_id(contract.user_id) + " Wk" + fac.week;
          cpfac.user_id = contract.user_id;
          cpfac.contract_id = fac.contract_id;

          if (this.purchase == "no" || this.planning.filter((plan) => plan.user_id == cpfac.user_id && plan.project_id == contract.project_id)[0].inkoopfactuur == "yes") {
            result.push(cpfac);
          }
        }
      });
      this.generating = false;
      this.generated = true;
      this.allinvoices_gen = result.reverse();
    },
    userinfo(row) {
      return '<a href="/#/user/' + row.item.user_id + '" :style="{ cursor: \'pointer\'}" class="link-item"> ' + this.username_by_id(row.item.user_id) + "</a><br/>" + '<a href="mailto:' + this.user_by_id(row.item.user_id).email + '" class="link-item">' + this.user_by_id(row.item.user_id).email + "</a>";
    },
    invoiceuserinfo(row) {
      return row.item.invoiceemail ? '<a href="/#/user/' + row.item.invoiceemail + '" :style="{ cursor: \'pointer\'}" class="link-item"> ' + this.username_by_id(row.item.invoiceemail) + "</a><br/>" + '<a href="mailto:' + this.user_by_id(row.item.invoiceemail).email + '" class="link-item">' + this.user_by_id(row.item.invoiceemail).email + "</a>" : this.$i18n.t("validation.invoicecontactmissing");
    },
    company_attachment(item) {
      // console.log("><>",this.company_by_id(item.company_id).needsattachment)
      if (this.company_by_id(item.company_id).needsattachment == "yes") {
        if (item.urenbonnen.filter((u) => u.name.substring(0, 8) == "company_").length > 0) {
          return 2;
        } else {
          return 1;
        }
      } else {
        return 0;
      }
    },

    companyinfo(row) {
      let company = this.company_by_id(this.project_by_id(this.contract_by_id(row.item.contract_id).project_id).company_id);
      return '<a href="/#/company/' + company.id + '" :style="{ cursor: \'pointer\'}" class="link-item"> ' + company.company_name + "</a>";
    },
    email_invoices() {
      //check for items already exported
      var showWarning = false;
      this.filteredinvoices.forEach((invoiceline) => {
        if (invoiceline.salemailwarning) {
          showWarning = true;
        }
      });
      if (showWarning) {
        let message = this.$i18n.t("labels.confirmmailinvoices");
        this.$modal.hide("popup_modal");
        this.$modal.show(
          popup_modal,
          {
            message: message,
          },
          {
            name: "popup_modal",
            draggable: false,
            height: "auto",
            width: "500px",
          },
          {
            "before-close": this.checkEmailModalCheck,
          },
        );

        this.$emit("close");
      } else {
        this.reallyMail();
      }
    },
    checkEmailModalCheck() {
      if (this.confirm_modal.id == 1) {
        this.reallyMail();
      }
    },
    checkPurchaseEmailSelect(factuur, inkoopfactuur, company_id) {
      let ret = 0;
      ret = factuur.mailedinkoop == 1 ? 0 : inkoopfactuur != "no" ? 1 : 0;
      if (!(this.company_by_id(company_id).finqle == "" || this.company_by_id(company_id).finqle == undefined)) {
        ret = 0;
      }
      console.log(ret);
      return 0;
    },

    async reallyMail() {
      this.notrunning = false;
      // var invoice
      // await this.invoicedata.forEach(invoiceline => {
      for await (const invoiceline of this.filteredinvoices) {
        if (invoiceline.salemailselect == 1) {
          // generate invoice
          console.log("emailing invoice", invoiceline);
          // let data = {}
          // data.dates = this.getWeekDates(invoiceline.week.substring(0, 2), invoiceline.week.substring(3))
          // data.user_id = invoiceline.user_id
          // data.contract_id = invoiceline.contract_id
          // data.week = parseInt(invoiceline.week.substring(0, 2))
          // data.year = invoiceline.week.substring(3)
          // data.hourcode = invoiceline.hourcode?parseInt(invoiceline.hourcode):null
          // data.id = invoiceline.id
          // data.invoiceemail = invoiceline.invoiceemail
          // await this.sendSaleInvoiceEmail(data)
          try {
            await axios.post(this.server_url + "/generate_verkoop_combined", { project_id: invoiceline.project_id, week: invoiceline.week.substring(0, 2), year: invoiceline.week.substring(3) }).then(async () => {
              let invoiceemail = this.company_by_id(this.project_by_id(invoiceline.project_id).company_id).invoice_contants[0] ? this.user_by_id(this.company_by_id(this.project_by_id(invoiceline.project_id).company_id).invoice_contants[0]).id : null;

              var message = {};
              message.email = this.user_by_id(invoiceemail).email;
              message.name = this.username_by_id(invoiceemail);
              message.message = this.settings.combinedsalemessage;
              message.message = message.message.replaceAll(/\[week\]/gi, invoiceline.week.substring(0, 2));
              message.message = message.message.replaceAll(/\[project_name\]/gi, this.project_by_id(invoiceline.project_id).title);
              message.message = message.message.replaceAll(/\[first_name\]/gi, this.user_by_id(invoiceemail).firstname);
              // if (planningdata.project_reference_number) {
              // message.message = message.message.replaceAll(/\[project_reference_number\]/gi, "(" + planningdata.project_reference_number + ")")
              // } else {
              // message.message = message.message.replaceAll(/\[project_reference_number\]/gi, "")
              // }

              message.subject = this.settings.combinedsalesubject;
              message.subject = message.subject.replaceAll(/\[week\]/gi, invoiceline.week.substring(0, 2));
              message.subject = message.subject.replaceAll(/\[project_name\]/gi, this.project_by_id(invoiceline.project_id).title);
              message.subject = message.subject.replaceAll(/\[first_name\]/gi, this.user_by_id(invoiceemail).firstname);
              // if (planningdata.project_reference_number) {
              // message.subject = message.subject.replaceAll(/\[project_reference_number\]/gi, "(" + planningdata.project_reference_number + ")")
              // } else {
              // message.subject = message.subject.replaceAll(/\[project_reference_number\]/gi, "")
              // }
              // if(data.hourcode) {
              // message.subject = message.subject.replaceAll(/\[hourcode\]/gi, this.hourcode_by_id(parseInt(data.hourcode)).name)
              // message.message = message.message.replaceAll(/\[hourcode\]/gi, this.hourcode_by_id(parseInt(data.hourcode)).name)
              // } else {
              // message.subject = message.subject.replaceAll(/\[hourcode\]/gi, "")
              // message.message = message.message.replaceAll(/\[hourcode\]/gi, "")
              // }
              message.maindocuments = [];

              // if(data.hourcode){
              // message.maindocuments.push({ file: '/invoices/verkoopfactuur-' + data.contract_id + "-" + data.user_id + "-" + parseInt(data.week)+ "-" + parseInt(data.hourcode) + ".pdf", name: "Factuur" });
              // } else {
              message.maindocuments.push({ file: "/invoices/verzamel-" + invoiceline.project_id + "-" + invoiceline.week.substring(0, 2) + "-" + invoiceline.week.substring(3) + ".pdf", name: "Factuur" });
              // //urenbonnen
              // let bonnen = this.urenbonnen.filter(bon => {
              // return bon.contract_id == data.contract_id && bon.week == parseInt(data.week)
              // })
              // if (bonnen.length > 0) {
              // bonnen.forEach(bon => {
              //     if(bon.name.substring(0,6)!="intern"){
              //     message.maindocuments.push({ file: '/' + bon.file, name: bon.name });
              //     }
              // })
              // }
              // add default cc
              if (this.settings.combinesalecc) {
                message.cc = [];
                message.cc.push(this.settings.combinesalecc);
              }
              try {
                await axios.post("/api/contact_user", message).then((response) => {
                  console.log(">Maildone ", response);
                  if (response.status == 200) {
                    console.log("mark as exported");
                    let invoice = this.combinedfactuur_by_id(invoiceline.id);
                    invoice.mailedverkoop = 1;
                    axios.post("/api/set_combinedsale_mailed", { id: invoiceline.id, mailedverkoop: 1 });
                  }
                });
              } catch (err) {
                console.log(err);
                console.log(">MailError ", err);
                let invoice = this.combinedfactuur_by_id(invoiceline.id);
                invoice.mailedverkoop = 0;
                axios.post("/api/set_sale_mailed", { id: invoiceline.id, mailedverkoop: 0 });
              }
            });
          } catch (err) {
            console.log("Generate Error, ", err);
          }
        }
      }
      this.notrunning = true;
    },
    export_invoices() {
      //check for items already exported
      var showWarning = false;
      var manualinvoicesValid = true;
      this.filteredinvoices.forEach((invoiceline) => {
        if (this.purchase == "yes") {
          if (invoiceline.purchaseexportwarning) {
            showWarning = true;
          }
          if (invoiceline.inkoopfactuur == "no" && invoiceline.senddate == null && invoiceline.purchaseexportselect == 1) {
            manualinvoicesValid = false;
          }
        } else {
          if (invoiceline.saleexportwarning) {
            showWarning = true;
          }
        }
      });
      if (showWarning || !manualinvoicesValid) {
        let message = "";
        if (showWarning) {
          message = this.$i18n.t("labels.confirmexportinvoices");
        }
        if (!manualinvoicesValid) {
          if (message == "") {
            message = " " + this.$i18n.t("labels.confirmexportmanual");
          } else {
            message += "\n" + this.$i18n.t("labels.confirmexportmanual");
          }
        }
        this.$modal.hide("popup_modal");
        this.$modal.show(
          popup_modal,
          {
            message: message,
          },
          {
            name: "popup_modal",
            draggable: false,
            height: "auto",
            width: "500px",
          },
          {
            "before-close": this.checkExportModalCheck,
          },
        );

        this.$emit("close");
      } else {
        this.reallyExport();
      }
    },
    checkExportModalCheck() {
      if (this.confirm_modal.id == 1) {
        this.reallyExport();
      }
    },

    async reallyExport() {
      // make sure boekhoudgemak is active
      // console.log(this.settings.boekhoudprogramma, this.settings.database, this.settings.database=="" || this.settings.database==undefined)
      if (this.settings.boekhoudprogramma != "snelstart" && this.settings.boekhoudprogramma != "eboekhouden") {
        if (this.settings.boekhoudprogramma == "" || this.settings.boekhoudprogramma == undefined || this.settings.database == "" || this.settings.database == undefined) {
          console.log("boekhoudgemak not active, return");
          return;
        }
      }
      this.notrunning = false;
      for await (const invoiceline of this.filteredinvoices.filter((iv) => iv.purchaseexportselect == 1 || iv.saleexportselect == 1)) {
        console.log(invoiceline, this.purchase);
        console.log("invoiceline.purchase>0", invoiceline.purchase > 0);
        console.log("invoiceline.sale>0", invoiceline.sale > 0);
        // console.log(this.planning_by_id(this.contract_by_id(invoiceline.contract_id).planning_id))
        // console.log("project",this.project_by_id(this.contract_by_id(invoiceline.contract_id).project_id))
        // console.log("user",this.user_by_id(this.contract_by_id(invoiceline.contract_id).user_id))
        // console.log("company",this.company_by_id(this.project_by_id(this.contract_by_id(invoiceline.contract_id).project_id).company_id))
        let contract_id = this.contracts.filter((c) => c.project_id == invoiceline.project_id)[0].id;
        var planningdata = this.planning_by_id(this.contract_by_id(contract_id).planning_id);
        console.log("planningdata", planningdata);
        console.log("company", this.company_by_id(invoiceline.company_id));
        //purchase export
        var invoicedata = {};
        var now = new Date();
        var invoice;
        console.log("verkoop", invoiceline.saleexportselect);

        if (invoiceline.saleexportselect == 1 && invoiceline.sale > 0) {
          if (this.settings.boekhoudprogramma == "snelstart") {
            console.log("Snelstart verkoop", invoiceline);
            console.log("Snelstart plannignsdata", planningdata);
            invoicedata = {};
            now = new Date();
            invoicedata.factuurnummer = invoiceline.facnumverkoop ? invoiceline.facnumverkoop.substring(invoiceline.facnumverkoop.length - 8) : "unknown";
            if (this.combinedfactuur_by_id(invoiceline.id).invoicedate) {
              invoicedata.factuurdatum = this.dateToYYYYMMDD(this.combinedfactuur_by_id(invoiceline.id).invoicedate);
            } else {
              invoicedata.factuurdatum = this.dateToYYYYMMDD(now);
            }
            invoicedata.boekstuk = invoiceline.boekstuknummer;
            invoicedata.klant = {};
            invoicedata.klant.id = this.company_by_id(invoiceline.company_id).debnum;
            invoicedata.omschrijving = ("Week " + invoiceline.week + " " + invoiceline.facnumverkoop + " " + planningdata.project_name).substring(0, 30);
            invoicedata.factuurbedrag = invoiceline.sale.toFixed(2);
            invoicedata.boekingsregels = [];
            invoicedata.btw = [];
            var btwlinev = {};
            var gblinev = {};
            (gblinev.omschrijving = "Week " + invoiceline.week + " " + invoiceline.facnumverkoop), (gblinev.bedrag = invoiceline.sale.toFixed(2));
            gblinev.grootboek = {};
            let declagbrule = "grootboek";

            let btwcode = planningdata.btw_verlegd;
            if (this.company_by_id(invoiceline.company_id).btw_verlegd && this.company_by_id(invoiceline.company_id).btw_verlegd != "") {
              btwcode = this.company_by_id(invoiceline.company_id).btw_verlegd;
            }

            if (btwcode == "yes") {
              gblinev.grootboek.id = this.settings.saleshiftledgeraccountss.guid;
              gblinev.btwSoort = "Geen";
            } else {
              if (btwcode == "low") {
                gblinev.grootboek.id = this.settings.salenotshiftledgerlowaccountss.guid;
                gblinev.btwSoort = "Laag";
                invoicedata.factuurbedrag = (1.09 * invoiceline.sale).toFixed(2);

                gblinev.bedrag = invoiceline.sale.toFixed(2);

                btwlinev.btwSoort = "VerkopenLaag";
                btwlinev.btwBedrag = (invoiceline.sale * 0.09).toFixed(2);
                invoicedata.btw.push(btwlinev);
                declagbrule = "grootboeklaag";
              } else {
                gblinev.grootboek.id = this.settings.salenotshiftledgerhighaccountss.guid;
                invoicedata.factuurbedrag = (1.21 * invoiceline.sale).toFixed(2);

                gblinev.btwSoort = "Hoog";
                gblinev.bedrag = invoiceline.sale.toFixed(2);

                btwlinev.btwSoort = "VerkopenHoog";
                btwlinev.btwBedrag = (invoiceline.sale * 0.21).toFixed(2);
                invoicedata.btw.push(btwlinev);
                declagbrule = "grootboekhoog";
              }
            }

            invoiceline.salefull.forEach((declacat) => {
              // console.log("decla", declacat);
              if (parseFloat(declacat.costs) > 0 && this.declaratie_by_id(declacat.id)[declagbrule] != null && this.declaratie_by_id(declacat.id)[declagbrule] != "") {
                let declagb = {};
                declagb.bedrag = declacat.costs;
                declagb.btwSoort = gblinev.btwSoort;
                declagb.grootboek = {};
                declagb.grootboek.id = this.declaratie_by_id(declacat.id)[declagbrule];
                declagb.omschrijving = this.declaratie_by_id(declacat.id).name + " " + gblinev.omschrijving;
                invoicedata.boekingsregels.push(declagb);
                gblinev.bedrag -= declacat.costs;
              }
            });
            invoicedata.boekingsregels.push(gblinev);
            invoicedata.boekingsregels.forEach((bv) => {
              bv.bedrag = parseFloat(bv.bedrag).toFixed(2);
            });

            console.log(invoicedata);

            try {
              const response = await axios.post("/api/snelstart_create_verkoop", invoicedata);
              if (response) {
                if (response.status == 200) {
                  invoice = this.combinedfactuur_by_id(invoiceline.id);
                  invoice.exportedverkoop = 1;
                  await axios.post("/api/set_combinedsale_exported", { id: invoiceline.id, exportedverkoop: 1 });
                  //upload pdf
                  if (response.data.id) {
                    let ss_invoiceid = response.data.id;
                    // generate invoice

                    await axios.post(this.server_url + "/generate_verkoop_combined", { project_id: invoiceline.project_id, week: invoiceline.week.substring(0, 2), year: invoiceline.week.substring(3) }).then(() => {
                      var invoice;
                      invoice = "verzamel-" + invoiceline.project_id + "-" + invoiceline.week.substring(0, 2) + "-" + invoiceline.week.substring(3) + ".pdf";
                      axios.post("/api/snelstart_invoice_verkoop", { invoice: invoice, id: ss_invoiceid });
                      // this.generate_inkoop = false
                    });
                  }
                }
                if (response.data.status && response.data.status != 200) {
                  console.log("DAS MIS", response.data.messages);
                  let errormessages = "";
                  response.data.messages.forEach((element) => {
                    errormessages += element.message + "<br>";
                  });
                  invoice = this.combinedfactuur_by_id(invoiceline.id);
                  invoice.exportedverkoop = 0;
                  await axios.post("/api/set_combinedsale_exported", { id: invoiceline.id, exportedverkoop: 0 });
                  this.$modal.hide("popup_modal");
                  this.$modal.hide("popup_confirm");
                  this.$modal.show(
                    popup_confirm,
                    {
                      message: errormessages,
                      header: this.$t("labels.boekhoudgemakfout") + " " + invoice.facnumverkoop,
                    },
                    {
                      name: "popup_confirm",
                      draggable: false,
                      height: "auto",
                      width: "90%",
                    },
                  );
                }
              }
            } catch (err) {
              console.log(err);
            }
          }
        }
      }
      this.notrunning = true;
    },
    async sendBoekhoudgemak(invoicedata, invoice, invoiceline) {
      const response = await axios.post("/api/create_verkoop", invoicedata);
      if (response) {
        // console.log('response', response)

        if (response.status == 200) {
          invoice = this.factuur_by_id(invoiceline.id);
          invoice.exportedverkoop = 1;
          await axios.post("/api/set_sale_exported", { id: invoiceline.id, exportedverkoop: 1 });
        }
        if (response.data.status && response.data.status != 200) {
          console.log("DAS MIS", response.data.messages);
          let errormessages = "";
          response.data.messages.forEach((element) => {
            errormessages += element.message + "<br>";
          });
          invoice = this.factuur_by_id(invoiceline.id);
          invoice.exportedverkoop = 0;
          await axios.post("/api/set_sale_exported", { id: invoiceline.id, exportedverkoop: 0 });
          this.$modal.hide("popup_modal");
          this.$modal.hide("popup_confirm");
          this.$modal.show(
            popup_confirm,
            {
              message: errormessages,
              header: this.$t("labels.boekhoudgemakfout") + " " + invoice.facnumverkoop,
            },
            {
              name: "popup_confirm",
              draggable: false,
              height: "auto",
              width: "90%",
            },
          );
        }
      }
    },
    generate_factuur(index) {
      index.pdfgenerating = true;
      let data = {};
      data.dates = this.getWeekDates(index.week.substring(0, 2), index.week.substring(3));
      data.user_id = index.user_id;
      data.contract_id = index.contract_id;
      data.hourcode = index.hourcode != undefined ? parseInt(index.hourcode) : null;
      data.week = parseInt(index.week.substring(0, 2));
      console.log("data", data, index);

      try {
        axios.post("/api/generate_inkoop", data).then(() => {
          var routeUrl;
          if (data.hourcode == null) {
            routeUrl = this.server_url + "/media_invoices/factuur-" + index.contract_id + "-" + index.user_id + "-" + parseInt(index.week.substring(0, 2)) + ".pdf";
          } else {
            routeUrl = this.server_url + "/media_invoices/factuur-" + index.contract_id + "-" + index.user_id + "-" + parseInt(index.week.substring(0, 2)) + "-" + data.hourcode + ".pdf";
          }
          window.open(routeUrl, "_blank");
          index.pdfgenerating = false;
        });
      } catch (err) {
        console.log(err);
      }
    },
    async generate_combined(item) {
      await axios.post(this.server_url + "/generate_verkoop_combined", { project_id: item.project_id, week: item.week.substring(0, 2), year: item.week.substring(3) }).then(() => {
        var routeUrl;

        routeUrl = this.server_url + "/media_invoices/verzamel-" + item.project_id + "-" + item.week.substring(0, 2) + "-" + item.week.substring(3) + ".pdf";
        window.open(routeUrl, "_blank");
      });
    },
    async gen_invoice() {
      this.$bvModal.show("BSShowinvoiceDataID");
    },
    set_invoice_values(item) {
      this.showinvoice = item.id;
      this.$bvModal.show("BSSetinvoiceDataID");
    },
    setsaleamount(item) {
      this.showinvoice = item.id;
      this.$bvModal.show("BSSetSaleAmountCombinedID");
    },
    removeinvoice(row) {
      this.selectedID = row.item.id;
      let message = this.$i18n.t("labels.confirmdeletehead") + row.item.boekstuknummer + this.$i18n.t("labels.confirmdeletetail");
      this.$modal.hide("popup_modal");
      this.$modal.show(
        popup_modal,
        {
          message: message,
        },
        {
          name: "popup_modal",
          draggable: false,
          height: "auto",
          width: "500px",
        },
        {
          "before-close": this.modalClose,
        },
      );

      this.$emit("close");
    },
    modalClose() {
      if (this.confirm_modal.id == 1) {
        this.delete_factuur(this.selectedID);
        for (let i = 0; i < this.facturen.length; i++) {
          if (this.facturen[i].id == this.selectedID) {
            this.facturen.splice(i, 1);
          }
        }
      }
    },
    upload_factuur(item) {
      this.contract_id = item.contract_id;
      this.weeknumber = parseInt(item.week.substring(0, 2));
      this.yearnumber = parseInt(item.week.substring(3));
      this.companyattachment = false;
      this.internattachment = true;
      this.$bvModal.show("BSUploadUrenModalID");
    },
    upload_company_attachment(item) {
      this.contract_id = item.contract_id;
      this.weeknumber = parseInt(item.week.substring(0, 2));
      this.yearnumber = parseInt(item.week.substring(3));
      this.companyattachment = true;
      this.internattachment = false;

      this.$bvModal.show("BSUploadUrenModalID");
    },
    view_company_attachment(item) {
      let cu = this.urenbonnen.filter((u) => u.contract_id == item.contract_id && u.week == parseInt(item.week.substring(0, 2)) && u.name.substring(0, 8) == "company_");
      if (cu && cu[0].file) window.open(this.server_url + "/media_" + cu[0].file, "_blank");
    },
    select_all_email() {
      this.filteredinvoices.forEach((element) => {
        if (this.purchase == "yes") {
          element.purchasemailselect = element.inkoopfactuur == "no" ? 0 : 1;
          element.purchasemailwarning = element.purchasemailed == 1 && element.purchasemailselect;
        } else {
          element.salemailselect = 1;
          element.salemailwarning = element.salemailed == 1 && element.salemailselect;
        }
      });
    },
    select_none_email() {
      this.filteredinvoices.forEach((element) => {
        if (this.purchase == "yes") {
          element.purchasemailselect = 0;
          element.purchasemailwarning = false;
        } else {
          element.salemailselect = 0;
          element.salemailwarning = false;
        }
      });
    },
    select_not_emailed() {
      this.filteredinvoices.forEach((element) => {
        if (this.purchase == "yes") {
          element.purchasemailselect = element.purchasemailed == 1 ? 0 : 1;
          element.purchasemailwarning = false;
        } else {
          element.salemailselect = element.salemailed == 1 ? 0 : 1;
          element.salemailwarning = false;
        }
      });
    },
    select_all_export() {
      this.filteredinvoices.forEach((element) => {
        if (this.purchase == "yes") {
          element.purchaseexportselect = 1;
          element.purchaseexportwarning = element.purchaseexported == 1 && element.purchaseexportselect;
        } else {
          element.saleexportselect = 1;
          element.saleexportwarning = element.saleexported == 1 && element.saleexportselect;
        }
      });
    },
    select_none_export() {
      this.filteredinvoices.forEach((element) => {
        if (this.purchase == "yes") {
          element.purchaseexportselect = 0;
          element.purchaseexportwarning = false;
        } else {
          element.saleexportselect = 0;
          element.saleexportwarning = false;
        }
      });
    },
    select_not_exported() {
      this.filteredinvoices.forEach((element) => {
        if (this.purchase == "yes") {
          element.purchaseexportselect = element.purchaseexported == 1 ? 0 : 1;
          element.purchaseexportwarning = element.purchaseexported == 1 && element.purchaseexportselect;
        } else {
          element.saleexportselect = element.saleexported == 1 ? 0 : 1;
          element.saleexportwarning = element.saleexported == 1 && element.saleexportselect;
        }
      });
    },
    needtoexport() {
      var ret = false;
      this.filteredinvoices.forEach((element) => {
        if (this.purchase == "yes") {
          if (!ret) {
            ret = element.purchaseexportselect == 1;
          }
        } else {
          if (!ret) {
            ret = element.saleexportselect == 1;
          }
        }
      });
      return ret;
    },
    pexportcheck(item) {
      item.purchaseexportwarning = item.purchaseexported == 1 && item.purchaseexportselect;
    },
    sexportcheck(item) {
      item.saleexportwarning = item.saleexported == 1 && item.saleexportselect;
    },
    pmailcheck(item) {
      item.purchasemailwarning = item.purchasemailed == 1 && item.purchasemailselect;
    },
    smailcheck(item) {
      item.salemailwarning = item.salemailed == 1 && item.salemailselect;
    },
    email_status(status) {
      for (const invoiceline of this.filteredinvoices) {
        let invoice = this.combinedfactuur_by_id(invoiceline.id);

        if (invoiceline.salemailselect == 1) {
          invoice.mailedverkoop = status;
          axios.post("/api/set_combinedsale_mailed", { id: invoiceline.id, mailedverkoop: status });
        }
      }
    },
    export_status(status) {
      for (const invoiceline of this.filteredinvoices) {
        let invoice = this.combinedfactuur_by_id(invoiceline.id);

        if (invoiceline.saleexportselect == 1) {
          invoice.exportedverkoop = status;
          axios.post("/api/set_combinedsale_exported", { id: invoiceline.id, exportedverkoop: status });
        }
      }
    },
    showurenbonnen(row) {
      this.urenbonnenfromrow = row.urenbonnen;
      this.$bvModal.show("BSManageUrenbonnenModalID");
    },
  },
  components: {
    flatPickr,
    BSSetSaleAmountCombined,
    BSUploadUserModal,
    BSManageUrenbonnenModalID,
    BSShowinvoiceDataID,
    BSsetFacNumModel,
  },
  watch: {
    $route() {
      this.purchase = this.$route.params.sale == "purchase" ? "yes" : "no";
    },
  },
};
</script>
